<template>
  <div class="modal-imagenes">
      <vs-popup class="modal-imagenes" fullscreen title="Imágenes" :active.sync="showModalImages" button-close-hidden>
        <list :multiple="multiple" :seleccionar="true" @imagenSeleccionada="imagenSeleccionada($event)"></list>

        <button type="button" class="icon-close-modal" @click="close()">Cerrar</button>
      </vs-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import List from '@/components/app/imagenes/List'

export default {
  data() {
    return {
      popupActive: false
    }
  },
  props: {
    multiple: Boolean
  },
  components: {
    List
  },
  methods: {
      close() {
          this.$store.dispatch('updateModalImagesStatus', false)

          this.$emit('resetMultiple')
      },
      imagenSeleccionada(data) {
        this.$emit('imagenSeleccionada', data)

        this.close()
      }
  },
  computed: {
      ...mapState(['showModalImages'])
  }
}
</script>

<style lang="scss">
.modal-imagenes {
  position: relative;
  z-index: 100000;
}

.icon-close-modal {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 100001;
}

.vs-component.con-vs-popup.modal-imagenes.vs-popup-primary.fullscreen {
  position: fixed;
  z-index: 500000 !important;
}
</style>